import ActionBtn from 'components/ActionBtn';
import cashierActions from 'features/cashier/services/actions';
import { ITEM_HANDLE_MODE } from 'features/cashier/services/constants';
import cashierSelectors from 'features/cashier/services/selectors';
import React from 'react';
import { useAppDispatch } from 'store/hooks';

const DeleteItemButton = () => {
  const dispatch = useAppDispatch();
  const active = cashierSelectors.getItemModeVisible(ITEM_HANDLE_MODE.DELETE_ITEM);
  return (
    <ActionBtn
      ntype={active ? 'PRIMARY' : 'SECONDARY'}
      icon="closeModal"
      label='Delete Item'
      onClick={() => dispatch(cashierActions.toggleVisibleDeleteItemMode())}
    />
  );
};

export default DeleteItemButton;